import BottomSheet from '@/components/Common/DesignSystem/BottomSheet/BottomSheet';
import { IRaffleDealItem } from '@/models/RaffleDeal/interfaces/IRaffleDealPromotionsPayload';
import { RaffleDealStoreCtx } from '@/stores/RaffleDealStore';
import { observer } from 'mobx-react-lite';
import moment from 'moment-timezone';
import React, { useContext } from 'react';

import styles from './RaffleDealWinnerBottomSheet.module.scss';

interface IRaffleDealWinnerBottomSheetProps {
  isOpen: boolean;
  close: () => void;
  deal: IRaffleDealItem;
}

const RaffleDealWinnerBottomSheet: React.FC<IRaffleDealWinnerBottomSheetProps> = ({ isOpen, close, deal }) => {
  const store = useContext(RaffleDealStoreCtx);

  const drawAt = moment(deal.drawAt).format('YYYY년 MM월 DD일(dd)');
  return (
    <BottomSheet isOpen={isOpen} onRequestClose={close}>
      {{
        title: '당첨자 명단',
        body: (
          <section className={styles.container}>
            <div className={styles.textWrap}>
              <p>안녕하세요. NOL입니다.</p>
              <p>&lt;{deal.productName}&gt; 에 당첨되신 모든 분들 축하드립니다.</p>
              <br />
              <p>이번 {store.PromotionTitle}에 당첨된 인원은 아래의 리스트를 확인해 리스트를 확인해주세요.</p>
              <br />
              <p>당첨된 분들의 경품 수령을 위해, LMS를 통해 별도 안내를 해드릴 예정이오니 참고 부탁드립니다.</p>
            </div>

            <hr className={styles.divider} />

            <div>
              <p className={styles.date}>{drawAt}</p>
              <p className={styles.productName}>{deal.productName}</p>

              <table className={styles.tableWrap}>
                <thead>
                  <tr>
                    <th>닉네임</th>
                    <th>이름</th>
                    <th>당첨자 휴대폰 번호</th>
                  </tr>
                </thead>
                <tbody>
                  {store.winners?.map((winner, idx) => (
                    <tr key={idx}>
                      <td>{winner.maskedNickName}</td>
                      <td>{winner.maskedName}</td>
                      <td>{winner.maskedPhoneNumber}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        ),
      }}
    </BottomSheet>
  );
};

export default observer(RaffleDealWinnerBottomSheet);
